import React, { useState } from "react";
import { Card, Divider, Box } from "@material-ui/core";

import { useStyles } from "./DocumentCardStyles";
import Button from "../../Button/Button";
import { countryListData } from "../../../../../utils/countries";
import TextInput from "../../TextInput/TextInput";
import Select from "../../Select/Select";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { useRegistroIngresoSession } from "../../../../../views/LogisticPark/RegistroIngreso/session/RegistroIngresoSessionContext";

interface DocumentCardProps {
  noBorder?: boolean;
  onSubmit?: (values: { country: string; dni: string }, userData?: any) => void;
  mode?: "entry" | "exit";
}

const DocumentCard: React.FC<DocumentCardProps> = ({ noBorder = false, onSubmit, mode }) => {
  const classes = useStyles();
  const { t, BundleKey } = useTranslation();
  const [country, setCountry] = useState("ARG");
  const [dni, setDni] = useState("");
  const trimmedDni = dni.trim();

  const { tabs, activeTabId, appendTab, searchUser, setActiveTab, findExistingTab } =
    useRegistroIngresoSession();

  const activeTab = tabs.find((tab) => tab.id === activeTabId);
  const isSearching = activeTab?.isSearching ?? false;
  const canSubmit = Boolean(country && trimmedDni) && !isSearching;

  const handleSubmit = async () => {
    if (!canSubmit) return;

    const currentMode = mode || "entry";
    const existingTab = findExistingTab(trimmedDni, country, currentMode);

    if (existingTab) {
      setActiveTab(existingTab.id);
      onSubmit?.({ country, dni: trimmedDni }, existingTab.values);
    } else {
      const tabId = appendTab(undefined, currentMode);
      const enrichedUser = await searchUser(tabId, trimmedDni, country);
      onSubmit?.({ country, dni: trimmedDni }, enrichedUser ?? undefined);
    }
  };

  return (
    <Card className={`${classes.card}${noBorder ? ` ${classes.noBorderCard}` : ""}`}>
      <>
        <Box display="flex" alignItems="center">
          <Divider style={{ flex: 1 }} />
          <Box mx={2} fontWeight={500} color="#5B5D66">
            {t(BundleKey.MANUALINPUT_SEPARATOR)}
          </Box>
          <Divider style={{ flex: 1 }} />
        </Box>
        <Box className={classes.inputsRow}>
          <Select
            value={country}
            onChange={(val) => setCountry(val as string)}
            options={countryListData.map((c) => ({ value: c.value, label: c.name }))}
            placeholder={t(BundleKey.MANUALINPUT_COUNTRY)}
            className={classes.countrySelect}
            isSearchable
          />
          <TextInput
            className={classes.dniInput}
            value={dni}
            onChange={(value) => setDni(value)}
            placeholder={t(BundleKey.MANUALINPUT_DNI)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSubmit();
            }}
          />

          <Button
            size="large"
            className={classes.submitButton}
            disabled={!canSubmit}
            onClick={handleSubmit}
          >
            {isSearching ? "Cargando..." : t(BundleKey.MANUALINPUT_SUBMIT)}
          </Button>
        </Box>
      </>
    </Card>
  );
};

export default DocumentCard;
